import { render, staticRenderFns } from "./QuizTemplate3.vue?vue&type=template&id=400ecd89"
import script from "./QuizTemplate3.vue?vue&type=script&lang=js"
export * from "./QuizTemplate3.vue?vue&type=script&lang=js"
import style0 from "./QuizTemplate3.vue?vue&type=style&index=0&id=400ecd89&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports